<template>
  <AppointmentsReport v-if="initialPageData" v-bind="initialPageData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import AppointmentsReport from "@/Job/Appointments.vue";


const initialPageData = ref<{
  source: string;
  filters: any[]
}|null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, { method: 'GET' }).then(res => res.json());
  initialPageData.value = res;
})
</script>

<style scoped>

</style>